<template>
    <div
        class="mr-fake-checkbox__wrapper"
        :class="{
            'mr-fake-checkbox__disabled': (disabled === true && data.checked === false) || disabledAlways === true,
        }"
    >
        <label class="mr-cursor-pointer">
            <input
                :id="`${name}_${data.id}`"
                type="checkbox"
                :value="data.id"
                :checked="data.checked"
                :name="name"
                :disabled="(disabled === true && data.checked === false) || disabledAlways === true"
                @change="updateValue(data, $event)"
            >

            <span class="check-mark" />
            <span class="mr-fake-checkbox-default-text cp-cursor-pointer">{{ data.name }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: ['data', 'name', 'filterKey', 'action', 'namespace', 'disabled', 'disabledAlways'],
    methods: {
        updateValue(data, $event) {
            const value = {
                name: this.name,
                id: data.id,
                bool: $event.target.checked,
            };
            this.$emit('click', value);

            // TODO:: TS clear
            if (this.action) {
                const checkbox = { name: this.name, id: data.id, bool: $event.target.checked };
                this.$store.dispatch(this.action, { key: this.filterKey, checkbox: checkbox });
                this.$emit('click');
            }
        },
    },
};
</script>
